import * as React from 'react'

import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'

import {
	faList,
	faTimes,
	faSortUp,
	faSortDown,
	faSpinner,
	faSync,
	IconDefinition,
	faCogs,
	faUser,
	faCopy,
	faEdit,
	faExclamationTriangle,
	faSort,
	faComment,
	faReply,
	faBold,
	faItalic,
	faUnderline,
	faFloppyDisk,
	faPlus,
	faAngleRight,
	faAngleDown,
	faCheck,
} from '@fortawesome/free-solid-svg-icons'

export enum IconType {
	User = 'User',
	Settings = 'Settings',
	Danger = 'Warning',

	Add = 'Add',
	Duplicate = 'Duplicate',
	Edit = 'Edit',
	CloseOrDelete = 'Times',
	Save = 'Save',

	// icon in the corner when container is visible or not visible
	Closed = 'Closed',
	Opened = 'Opened',

	List = 'List',

	Sort = 'Sort',
	SortUp = 'SortUp',
	SortDown = 'SortDown',

	Spinner = 'Spinner',
	Sync = 'Sync',

	Comment = 'Comment',
	Reply = 'Reply',

	Check = 'Check',

	FontBold = 'FontBold',
	FontItalic = 'FontItalic',
	FontUnderlined = 'FontUnderlined',
}

const iconMap: Record<IconType, IconDefinition> = {
	[IconType.User]: faUser,
	[IconType.Settings]: faCogs,
	[IconType.Duplicate]: faCopy,
	[IconType.Edit]: faEdit,
	[IconType.Danger]: faExclamationTriangle,
	[IconType.List]: faList,
	[IconType.Add]: faPlus,
	[IconType.CloseOrDelete]: faTimes,
	[IconType.Sort]: faSort,
	[IconType.SortUp]: faSortUp,
	[IconType.SortDown]: faSortDown,
	[IconType.Save]: faFloppyDisk,
	[IconType.Closed]: faAngleRight,
	[IconType.Opened]: faAngleDown,
	[IconType.Spinner]: faSpinner,
	[IconType.Sync]: faSync,
	[IconType.Comment]: faComment,
	[IconType.Reply]: faReply,
	[IconType.Check]: faCheck,
	[IconType.FontBold]: faBold,
	[IconType.FontItalic]: faItalic,
	[IconType.FontUnderlined]: faUnderline,
}


interface IconProps extends Omit<FontAwesomeIconProps, 'icon' | 'spin' | 'huge'> {
	icon: IconType
	spin?: boolean
	huge?: boolean
}

// forwardRef instead of normal component so attributes like "id" or "onClick" are not duplicated.
// This way, the user can use the Icon component as if it was a normal <FontAwesomeIcon> component.
const Icon = React.forwardRef<SVGSVGElement, IconProps>(
	({ icon, spin = false, huge = false, ...rest }, ref) => {
		const fontAwesomeIconDefinition = iconMap[icon]

		if (!fontAwesomeIconDefinition) {
			return <>[${icon}]</>
		}

		return (<FontAwesomeIcon
			ref={ref}
			icon={fontAwesomeIconDefinition}
			size={huge ? '8x' : rest.size}
			spin={spin}
			{...rest}
		/>)
	}
)

Icon.displayName = 'ReadPeakIcon'

export default Icon
